import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import logo from '../images/logo.png';
import './Container.js.css';
import { Link, Route } from 'react-router-dom';
import Routes from '../config/Routes';
import Parsers from '../Tools/Parsers';
import GenericHelper from '../Tools/GenericHelper';
import Labels from '../Labels';

export default class Container extends React.Component {

    static IsLoaded = false;

    constructor(props) {
        super(props);
        this.state = {
            menu: Routes.Pages,
            user: global.user,
            current: props.context,
            currentProps: props.props,
            menu_state: false,
            msg: Labels.GetLabel("states.msg", null),
            pathParameters: []
        };
    }

    componentDidMount() {
        this.setState({ user: global.user, pathParameters: this.exctractPath() });
        setTimeout(() => {
            Container.IsLoaded = true;
        }, 1);
    }

    exctractPath() {
        var r = window.location.pathname.split('/');
        return r;
    }

    toogleLanguage() {
        Labels.toggleLanguage();
        this.setState({ language: global.applanguage });
        try {
            global.page.setState({ language: global.applanguage });
        } catch (e) { }
    }

    checkVisibility(target, level) {
        var c = typeof level === "undefined" ? this.state.current : level;
        if (typeof c.PageInfo !== "undefined" && typeof c.PageInfo.parent !== "undefined") {
            if (target === c.PageInfo.parent)
                return true;
            for (let j = 0; j < Routes.Pages.length; j++)
                if (c.PageInfo.parent == Routes.Pages[j] &&
                    this.checkVisibility(target, Routes.Pages[j])) return true;
        }
        return false;
    }

    parsePath(current, path) {
        var r = path;
        if (current) {
            var p = path.split('/');
            r = "";
            for (let i = 0; i < p.length; i++)
                if (p[i].length > 0)
                    r += "/" + (i < this.state.pathParameters.length && p[i].indexOf(":") == 0 ? this.state.pathParameters[i] : p[i]);
        }
        return r;
    }

    renderItem(item, level) {
        var r = null;
        if (typeof item.PageInfo === "object") {
            if (level != 0 || typeof item.PageInfo.parent === "undefined") {
                var c = this.state.current === item || this.checkVisibility(item);

                if (c) {
                    var asd = 0;
                } 

                var p = Routes.CheckRoute(item);

                if (level != 0 && this.state.current !== item && c && p != null) {
                    return Routes.getChildren(item).map((sub) => this.renderItem(sub, level));
                } else {
                    r = p == null && item.PageInfo.show != false && (item.PageInfo.hidden !== true || c) ?
                        <div>
                            <Link to={this.parsePath(c, item.PageInfo.path)} className={"cpnt_container_side_menu_item" + (c ? " selected" : "")}>
                                <FontAwesomeIcon icon={item.PageInfo.icon} className="cpnt_container_side_menu_item_icon" />
                                <div className="cpnt_container_side_menu_label" >{Labels.GetLabel(item.PageInfo.name)}</div>
                            </Link>
                            {
                                c ?
                                    <div className="cpnt_container_side_menu_item_children">
                                        {Routes.getChildren(item).map((sub) => this.renderItem(sub, level + 1))}
                                    </div>
                                    : null
                            }
                        </div> : null;
                }
            }
        }
        return r;
    }

    render() {
        return (
            <div className="cpnt_container" >
                {
                    this.state.msg != null && this.state.msg.length > 0 ?
                        <div className="cpnt_container_msg" >{this.state.msg}</div> : null}
                <div className={"cpnt_container_inner " + (Container.IsLoaded ? "" : " first_show") + (this.state.msg.length > 0 ? " hasmsg" : "")}>
                    <div className="cpnt_container_side_menu">
                        <div className="cpnt_container_side_menu_content">
                            <div className="cpnt_container_side_menu_logo">
                                <img className="cpnt_container_side_menu_logo_image" src={logo} alt="LONGPING HIGH-TECH" />
                            </div>
                            <Link to={Routes.MyUser.PageInfo.path} className="cpnt_container_side_menu_user">
                                <FontAwesomeIcon icon="user-circle" className="cpnt_container_side_menu_user_icon" />
                                <div className="cpnt_container_side_menu_user_info">
                                    <div className="cpnt_container_side_menu_user_name">{this.state.user != null ? Parsers.parseUpperCase(GenericHelper.parseInformation(this.state.user.personValue, 1, "valueType")) : "USER"}</div>
                                    <div className="cpnt_container_side_menu_user_email">{this.state.user != null ? Parsers.parseUpperCase(GenericHelper.parseInformation(this.state.user.personValue, 3, "valueType")) : "EMAIL"}</div>
                                </div>
                            </Link>
                            <div className="cpnt_container_side_menu_itens">
                                <div className="cpnt_container_side_menu_itens_listing" style={{ display: this.state.menu_state ? "block" : "none" }}>
                                    {this.renderItem(Routes.GetHome())}
                                    {
                                        this.state.menu.map(
                                            (item) => this.renderItem(item, 0)
                                        )
                                    }
                                </div>
                                <div className="cpnt_container_side_menu_btn" onClick={() => this.setState({ menu_state: !this.state.menu_state })}><FontAwesomeIcon icon="list" /> Menu</div>
                            </div>
                        </div>
                        <div className="cpnt_container_side_menu_language" onClick={() => this.toogleLanguage()}><FontAwesomeIcon icon="language" /> {global.applanguage == "EN" ? "English" : "Português"}</div>
                        <div className="cpnt_container_side_menu_version">{Labels.GetLabel("generic.version")}: {Labels.GetLabel("version.current")}</div>
                    </div>
                    <div className="cpnt_container_content">{this.props.children}</div>
                </div></div>

        );
    }
}